import {Typography} from "@mui/material";
import AdminInner from "../../../components/layout/admin_inner";
import {H1, Typographies} from "../../../components/utils/typography_consts";
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";

export const AdminBillingPage = () => {
	const navigate = useNavigate();

	useEffect(() => {
		navigate("/app/admin/billing/overview");
	}, []);

	return (
		<AdminInner>

			<Typography mb={3} variant={Typographies.h4} component={H1}>
				Bienvenido al Módulo de Facturación
			</Typography>

		</AdminInner>
	);
};